module.exports = __webpack_public_path__ + "img/bathtub.70c78c4c.svg";